const fr = {
    splash: {
        start: {
            helper: "Appuyez sur le bouton pour commencer",
            button: "Commencer la commande"
        },
        banner: {
            title: "Bienvenue chez {ORGANISATION} !",
            content: "Utilisez cette borne en libre-service pour commander facilement vos billet(s) d'entree."
        }
    },
    catalog: {
        loading: "Chargement...",
        tabs: {
            ongoing: "En cours",
            all: "Tout"
        },
        items: {
            select: "Selectionner",
            empty: "Aucun evenement a venir !"
        }
    },
    cart: {
        title: "Ma reservation",
        empty: "Aucun billet dans votre reservation pour le moment !",
        items: {
            tickets: "Billets",
            date: "Date",
            time: "Heure"
        },
        total: "Montant total",
        buttons: {
            checkout: "Payer",
            cancel: "Annuler"
        }
    },
    booking: {
        steps: {
            quantity: {
                title: "Quantite de billets"
            },
            upsell: {
                title: "Options supplementaires pour votre commande"
            },
            plot: {
                title: "Reservation",
                empty: "Aucun creneau de reservation n'est disponible.",
                now: "Vous avez choisi un creneau pour entrer maintenant.",
                change: "Modifier"
            }
        },
        buttons: {
            continue: "Continuer",
            return: "Retour",
            cancel: "Annuler"
        }
    },
    checkout: {
        loading: "Chargement...",
        steps: {
            payment: "Terminez le paiement sur le terminal de paiement...",
            acts: {
                payment: "Terminez le paiement par carte ou en especes...",
                paymentLeft: "Il vous reste {paymentLeft} a payer",
                cancel: "Annuler"
            },
            tickets: "Paiement reussi ! Veuillez prendre vos billets...",
            tickets_info: "Souhaitez-vous aussi recevoir un recu de paiement ?",
            receipt: "Veuillez prendre votre recu...",
            receipt_info: "Votre recu de paiement a ete imprime.",
            failures: {
                transaction: {
                    title: "Le paiement n'a pas ete finalise !",
                    description: "Vous pouvez reessayer la transaction."
                },
                print: {
                    title: "Les billets et le recu n'ont pas pu etre imprimes !",
                    description: "Demandez a un employe de verifier l'imprimante. Vos billets et votre recu seront tout de meme imprimes ensuite."
                }
            },
            error: "La commande n'a pas pu etre finalisee !"
        },
        buttons: {
            retry: "Reessayer",
            cancel: "Retour",
            next: "Client suivant",
            yes: "Oui",
            yes_info: "Je veux un recu !",
            no: "Non",
            no_info: "Pas besoin de recu !",
            reprint_tickets: "Reimprimer les billets",
            reprint_tickets_countdown: "Reimprimer les billets ({seconds}s)"
        }
    },
    errors: {
        audience_not_found: "Le public cible est introuvable.",
        captcha_invalid: "Le CAPTCHA est invalide. Rechargez la page et recommencez la commande.",
        coupon_expired: "Ce coupon a expire.",
        coupon_invalid: "Le code coupon fourni est invalide.",
        coupon_product_mismatch: "Ce coupon ne peut pas etre utilise pour ce produit.",
        coupon_redemptions_exceeded: "Ce coupon a deja ete entierement utilise.",
        customer_field_invalid: "Un champ du formulaire est mal rempli. Verifiez vos informations.",
        customer_field_missing: "Un champ du formulaire est manquant. Verifiez vos informations.",
        customer_token_invalid: "Le jeton client est invalide. Veuillez vous reconnecter.",
        customer_token_required: "Cette adresse e-mail est deja enregistree. Veuillez vous connecter avant de passer commande.",
        plot_capacity_insufficient: "Le creneau que vous essayez de reserver n'a plus de disponibilite. Veuillez en choisir un autre.",
        plot_not_found: "Le creneau que vous essayez de reserver n'est plus disponible.",
        product_max_quantity_exceeded: "Le nombre de billets depasse la quantite maximale autorisee. Veuillez la reduire.",
        product_min_quantity_exceeded: "Le nombre de billets est inferieur a la quantite minimale requise. Veuillez l'augmenter.",
        product_not_found: "Le produit que vous essayez de commander n'est plus disponible.",
        rebook_invalid: "La nouvelle reservation est invalide.",
        rebook_product_mismatch: "La nouvelle reservation ne peut pas etre utilisee avec le produit indique.",
        subscription_expired: "L'abonnement a expire.",
        subscription_inactive: "L'abonnement n'est plus actif. Il est probable qu'il n'y ait plus de disponibilite.",
        subscription_invalid: "L'abonnement est invalide.",
        subscription_not_found: "L'abonnement indique est introuvable.",
        subscription_product_mismatch: "L'abonnement ne donne pas acces a ce produit.",
        subscription_quantity_mismatch: "L'abonnement ne donne pas acces a ces quantites.",
        subscription_redemptions_exceeded: "L'abonnement a depasse son utilisation maximale.",
        subscription_used_today: "L'abonnement a deja ete utilise aujourd'hui.",
        upsell_not_allowed: "Cette option supplementaire ne peut pas etre commandee avec ce produit.",
        upsell_not_found: "L'option supplementaire est introuvable."
    },
    printer: {
        title: "Une erreur d'imprimante est survenue !",
        reload: "Reessayer",
        errors: {
            paper_empty: "Le papier est presque vide.",
            cover_open: "Le capot est ouvert.",
            device_offline: "Impossible de se connecter.",
            device_malfunction: "Une erreur generale est survenue."
        }
    }
};

export default fr;
